import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';

import { PREVENTIVE_TASK_EXECUTION_PATH } from '../../../../config/paths';

import {
  clearPreventiveTaskExecution,
  getPreventiveTaskExecution,
} from '../../../../actions/task-schedule/PreventiveTaskExecution';

import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';

import Content from '../../../layout/Content';
import Loader from '../../../common/Loader';
import NoDataResource from '../../../common/resource/NoDataResource';
import InternalResource from '../../../common/resource/InternalResource';

import PreventiveTaskExecutionBasicInformationResource from './resource/PreventiveTaskExecutionBasicInformationResource';
import PreventiveTaskExecutionResourceResource from './resource/PreventiveTaskExecutionResourceResource';

export const PreventiveTaskExecution = ({
  breadcrumbs,
  dispatchGetPreventiveTaskExecution,
  dispatchClearPreventiveTaskExecution,
  match: {
    params: { id: preventiveTaskExecutionId },
  },
  loading,
  preventiveTaskExecution,
}) => {
  useLayoutEffect(() => {
    dispatchGetPreventiveTaskExecution({ preventiveTaskExecutionId });

    return () => dispatchClearPreventiveTaskExecution();
  }, []);

  let content;

  if (loading) content = <Loader />;
  else if (preventiveTaskExecution.isEmpty())
    content = <NoDataResource returnPage={PREVENTIVE_TASK_EXECUTION_PATH} />;
  else {
    const preventiveTaskExecutionJson = preventiveTaskExecution.toJS();

    content = (
      <>
        <h3>Información Básica</h3>
        <PreventiveTaskExecutionBasicInformationResource
          {...preventiveTaskExecutionJson}
        />

        <div className="mb-3">
          <h3>Recursos Ejecutados</h3>
          <PreventiveTaskExecutionResourceResource
            preventiveTaskExecutionResourceList={
              preventiveTaskExecutionJson.preventiveTaskExecutionResourceList
            }
          />
        </div>

        <InternalResource
          id={preventiveTaskExecutionJson.id}
          createDate={preventiveTaskExecutionJson.createDate}
          lastUpdate={preventiveTaskExecutionJson.lastUpdate}
        />
      </>
    );
  }

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Ejecución Programada"
      content={content}
    />
  );
};

PreventiveTaskExecution.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchClearPreventiveTaskExecution: PropTypes.func.isRequired,
  dispatchGetPreventiveTaskExecution: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  match: matchPropTypes.isRequired,
  preventiveTaskExecution: PropTypes.instanceOf(Immutable.Map).isRequired,
};

PreventiveTaskExecution.defaultProps = {
  loading: false,
};

const mapDispatchToProps = {
  dispatchClearPreventiveTaskExecution: clearPreventiveTaskExecution,
  dispatchGetPreventiveTaskExecution: getPreventiveTaskExecution,
};

const mapStateToProps = ({ TaskScheduleUnit }) => ({
  breadcrumbs: [
    ...TaskScheduleUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Ejecuciones Programadas',
      href: PREVENTIVE_TASK_EXECUTION_PATH,
    },
    {
      text: 'Ver',
      href: '',
    },
  ],
  preventiveTaskExecution: TaskScheduleUnit.PreventiveTaskExecution.getIn([
    'current',
    'content',
  ]),
  loading: !TaskScheduleUnit.PreventiveTaskExecution.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PreventiveTaskExecution);
